import type { ReactNode } from 'react';
import { APP_BUILT_AT, APP_VERSION } from '@/generated/build-info';

/**
 * Rodapé do shell autenticado — versão do toolkit + data do build.
 *
 * `src/generated/build-info.ts` é escrito por `scripts/write-build-info.mjs`
 * antes do tsc/vite (versão do package.json na raiz, ou `APP_VERSION` /
 * `APP_BUILT_AT` no build da imagem).
 */
function formatBuiltAt(isoDate: string): string {
  const [y, m, d] = isoDate.split('-').map(Number);
  if (!y || !m || !d) return isoDate;
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(new Date(y, m - 1, d));
}

export function AppVersionFooter(): ReactNode {
  const dateLabel = APP_BUILT_AT ? formatBuiltAt(APP_BUILT_AT) : '—';

  return (
    <footer
      data-testid="app-version-footer"
      className="shrink-0 border-t border-neon/20 bg-surface-raised/90 px-4 py-1.5 text-center font-mono text-[11px] text-muted"
    >
      Toolkit - v.{APP_VERSION} - Atualizada em {dateLabel}
    </footer>
  );
}
